import {inject, runInInjectionContext} from '@angular/core';

import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, Router } from '@angular/router';

import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (route, state) => {

  const router = inject(Router);
  const authService = inject(AuthService);

  const auth = await authService.isAuthenticated()

  if(auth) {
    return true
  } else {
    return router.parseUrl('/login')
  }
};